<div class="item-container" *ngIf="item">
  <div class="item-left-container">
    <div class="item-icon background-primary-color">
      <span class="material-icons icon-business">
        business
      </span>
    </div>
    <div class="item-title text-content">
      {{item.name}}
    </div>
    <div class="item-description text-content" *ngIf="item.idsEmployees && item.idsEmployees.length > 0">
      {{item.idsEmployees.length}} atendentes
    </div>
  </div>


  <div class="item-right-container">
    <button mat-raised-button class="btn-action primary-color" (click)="updateChannel(item)">
        <img src="../../../../../assets/icons/lapis-edit.svg" />
    </button>

    <button mat-raised-button class="btn-action primary-color" (click)="deleteChannel(item)">
        <img src="../../../../../assets/icons/lixeira2.svg" />
    </button>

  </div>
</div>